(function () {
  var STORAGE_KEY = 'stickyBarDismissed';

  function readDismissed() {
    try {
      return sessionStorage.getItem(STORAGE_KEY) === '1';
    } catch (e) {
      return false;
    }
  }

  function dismiss(bar) {
    bar.hidden = true;
    document.body.style.paddingBottom = '0px';
    document.documentElement.classList.remove('sticky-bar-visible');
    try {
      sessionStorage.setItem(STORAGE_KEY, '1');
    } catch (e) {}
  }

  document.addEventListener('DOMContentLoaded', function () {
    var bar = document.getElementById('sticky-add-to-cart');
    if (!bar) return;

    if (readDismissed()) bar.hidden = true;

    var closeButton = bar.querySelector('.sticky-add-to-cart__close');
    if (closeButton) {
      closeButton.addEventListener('click', function () {
        dismiss(bar);
      });
    }
  });
})();
